<p-card header="Deine Dokumente*">
  <div class="flex flex-col gap-2">
    @if (documents.errors && documents.touched) {
      @if (documents.errors && documents.errors['required']) {
        <p-message severity="error">Wir benötigen mindestens das Zeugnis deines letzten Schulbesuchs im PDF-Format.</p-message>
      }
      @if (documents.errors && documents.errors['maxlength']) {
        <p-message severity="error">Bitte nicht mehr als {{ documents.errors['maxlength'].requiredLength }} Dokumente anfügen.</p-message>
      }
      @if (documents.errors && documents.errors['fileSize']) {
        <p-message severity="error">Alle Dokumente dürfen zusammen nicht mehr als{{ documents.errors['fileSize'].max | bytes }} groß sein.</p-message>
      }
    }

    <taures-message severity="info" header="Wir bitten darum, die Abschlusszeugnisse (Schule/Berufsausbildung/Studium) hochzuladen (verpflichtend)"
      ><b>Achtung:</b> Das Abschlusszeugnis der Berufsausbildung ist kein Ersatz für das Abschlusszeugnis der Schule.
    </taures-message>

    <section class="flex flex-col gap-2">
      <p>
        Zusätzlich freuen wir uns über Arbeitszeugnisse (nicht verpflichtend). Sollte noch kein Schulabschluss erreicht sein, benötigen wir das letzte
        vorhandene Zeugnis. Die Abschlusszeugnisse sollten im PDF-Format hochgeladen werden. Zudem benötigen wir Dein Motivationsschreiben, sofern die
        Motivation nicht schon unter <strong>Deine Motivation</strong> dargelegt wurde.
      </p>
      <p>Beschriftungen bitte wie folgt:</p>
      <ul class="list-disc pl-4">
        <li class="break-words">Nachname_Vorname_Art des Abschlusses.pdf</li>
        <li class="break-words">Nachname_Vorname_Motivationsschreiben.pdf</li>
      </ul>
      <p>Alle Dokumente zusammen dürfen nicht größer als 15 MB sein.</p>
    </section>

    <p-fileupload
      (onSelect)="onUploadFiles($event)"
      [multiple]="true"
      accept="application/pdf"
      invalidFileSizeMessageDetail="Maximal erlaubte Dateigröße ist 15MB."
      invalidFileSizeMessageSummary="Datei ist zu groß."
      invalidFileTypeMessageDetail="Erlaubte Dateien sind: .pdf"
      invalidFileTypeMessageSummary="Invalide Dateitypen"
      maxFileSize="15000000"
    >
      <ng-template let-chooseCallback="chooseCallback" pTemplate="header">
        <p-button
          type="button"
          (onClick)="choose($event, chooseCallback)"
          outlined
          severity="primary"
          icon="pi pi-upload"
          label="PDF-Dateien auswählen"
        ></p-button>
      </ng-template>
      <ng-template pTemplate="content">
        @if (documents.value.length === 0) {
          <taures-fileupload-dragdrop-placeholder />
        }
        @if (documents.value.length > 0) {
          <div class="p-fileupload-file-list">
            @for (file of documents.value; track file; let i = $index) {
              <taures-fileupload-file
                class="p-fileupload-file"
                [fileName]="file.filename"
                [fileSizeInBytes]="size(file.data)"
                [fileIndex]="i"
                [isPendingFile]="true"
                (removePendingFile)="remove(i)"
              />
            }
          </div>
        }
      </ng-template>
      <ng-template pTemplate="file">
        <!-- important for p-fileupload not to show the default list -->
      </ng-template>
    </p-fileupload>
  </div>
</p-card>
